import { ReactElement } from 'react'

import { ShareDocumentMenu } from '@features/invoices/elements/ShareDocumentMenu'
import { useMissingEInvoiceDetailsForInvoice } from '@features/invoices/hooks/eInvoices/useMissingEInvoiceDetailsForInvoice'
import { isDocumentTypeCreditNote } from '@features/invoices/utils/isDocumentTypeCreditNote'

import { useInvoice } from '../../../../contexts/invoiceContext'

export const ShareInvoiceMenu = (): ReactElement => {
  const { documentType, invoice, invoiceId } = useInvoice()
  const missingEInvoiceDetails = useMissingEInvoiceDetailsForInvoice(invoice)

  return (
    <ShareDocumentMenu
      billingStage={invoice?.billingStage}
      contactId={String(invoice?.customer.externalContactId)}
      customer={invoice?.customer}
      documentId={invoiceId}
      documentLocale={invoice?.locale}
      documentNumber={isDocumentTypeCreditNote(documentType) ? invoice?.creditNoteNumber : invoice?.invoiceNumber}
      documentStatus={invoice?.status?.status}
      documentType={documentType}
      eInvoiceAddressingLine={invoice?.eInvoiceAddressingLine}
      missingEInvoiceDetails={missingEInvoiceDetails}
    />
  )
}
